import { db } from '@/firebase/init';
import { PermissionFromStore } from '@/types/types';
import { getOrganizationPermissionsPath } from '@/utils/queryPaths';
import { collection, orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';

function useOrganizationPermissions(organizationId: string): PermissionFromStore[] {
  const permissionsQuery = useMemo(
    () =>
      query(
        collection(db, getOrganizationPermissionsPath(organizationId)),
        orderBy('email', 'asc'),
      ),
    [organizationId],
  );

  const permissions = useFirestoreCollection<PermissionFromStore>(
    ['organizationPermissions', organizationId],
    permissionsQuery,
  );

  return permissions;
}

export { useOrganizationPermissions };
